export default {
  locale: 'zh-cn',
  DatePicker: {
    chooseTime: 'éæ©æ¶é´',
    chooseDate: 'éæ©æ¥æ',
    Monday: 'ä¸', TuesDay: 'äº', Wednesday: 'ä¸', ThursDay: 'å', Friday: 'äº', Saturday: 'å­', Sunday: 'æ¥',
    MonthName: 'æ',
    YearName: 'å¹´',
    months: ['1æ', '2æ', '3æ', '4æ', '5æ', '6æ', '7æ', '8æ', '9æ', '10æ', '11æ', '12æ']
  },
  Select: {
    notFoundContent: 'æ å¹éç»æ'
  },
  Modal: {
    cancel: 'åæ¶',
    ok: 'ç¡®è®¤'
  },
  Page: {
    go: 'åå¾',
    per: 'æ¡/é¡µ',
    page: 'é¡µ',
    total: 'å±',
    result: 'æ¡è®°å½',
    next: 'ä¸ä¸é¡µ',
    first: 'ç¬¬ä¸é¡µ',
    last: 'æåä¸é¡µ',
    previous: 'ä¸ä¸é¡µ',
    back: 'åå',
    to: 'åå'
  }
};
